import { WithStyles, withStyles } from '@mui/styles';
import { ClientUserMapped } from '@tassat/fred-extended-definitions';

import ClientUserAccountList from './ClientUserAccountList';
import { muiStyles } from './styles';

export interface ClientUserAccountListProps extends WithStyles<typeof muiStyles> {
    mappedUser: ClientUserMapped;
}

export default withStyles(muiStyles)(ClientUserAccountList);